import { render } from "./GraficoTarefasAtrasadasPorProjeto.vue?vue&type=template&id=bf4fa1b8&scoped=true"
import script from "./GraficoTarefasAtrasadasPorProjeto.vue?vue&type=script&lang=js"
export * from "./GraficoTarefasAtrasadasPorProjeto.vue?vue&type=script&lang=js"

import "./GraficoTarefasAtrasadasPorProjeto.vue?vue&type=style&index=0&id=bf4fa1b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf4fa1b8"]])

export default __exports__